import { combineReducers, configureStore } from "@reduxjs/toolkit";
import userReducer from "./slice/userSlice";
import usersReducer from "./slice/usersSlice";
import questionReducer from "./slice/questionSlice";
import examReducer from "./slice/examSlice";
import examsReducer from "./slice/examsSlice";
import historyReducer from "./slice/historySlice";
import topicReducer from "./slice/topicSlice";
import leaderboardReducer from "./slice/leaderboardSlice";
import contactReducer from "./slice/contactSlice";
import dynamicExamReducer from "./slice/dynamicExamSlice";

const combinedReducer = combineReducers({
  user: userReducer,
  users: usersReducer,
  questions: questionReducer,
  exam: examReducer,
  exams: examsReducer,
  history: historyReducer,
  topic: topicReducer,
  leaderboard: leaderboardReducer,
  contact: contactReducer,
  dynamicExam: dynamicExamReducer,
});

const rootReducer = (state, action) => {
  if (action.type === "user/logoutComplete") {
    state = undefined;
  }
  return combinedReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
});
